document.addEventListener('change', function (e) {
  if (e.target.closest('form[action*="/cart/add"]')) {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
      window.dispatchEvent(new Event('shopify:section:load'));
    }, 50);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.getElementById('custom-toggle');
  const wrapper = document.getElementById('custom-notes-wrapper');

  if (!toggle || !wrapper) return;

  toggle.addEventListener('change', function () {
    if (toggle.checked) {
      wrapper.style.display = 'block';
    } else {
      wrapper.style.display = 'none';

      const textarea = wrapper.querySelector('textarea');
      if (textarea) textarea.value = '';
    }
  });
});
